import toast from 'react-hot-toast';

interface ToastOptions {
  title: string;
  message: string;
  duration?: number;
}

const toastStyles = {
  success: {
    style: {
      background: '#fff',
      color: '#000',
      padding: '16px',
      borderRadius: '8px',
      boxShadow:
        '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
      border: '1px solid #e5e7eb',
      fontSize: '14px',
    },
    iconTheme: {
      primary: '#059669',
      secondary: '#fff',
    },
  },
  error: {
    style: {
      background: '#fff',
      color: '#000',
      padding: '16px',
      borderRadius: '8px',
      boxShadow:
        '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
      border: '1px solid #e5e7eb',
      fontSize: '14px',
    },
    iconTheme: {
      primary: '#dc2626',
      secondary: '#fff',
    },
  },
};

export const showSuccessToast = ({ title, message }: ToastOptions) => {
  toast.success(message, {
    duration: 5000,
    position: 'top-right',
    ...toastStyles.success,
  });
};

export const showErrorToast = ({ title, message, duration }: ToastOptions) => {
  toast.error(message, {
    duration: duration || 3000,
    position: 'top-right',
    ...toastStyles.error,
  });
};

const UPDATE_TOAST_ID = 'app-update-toast';

export const showUpdateToast = () => {
  // Prevent duplicate toasts
  toast.dismiss(UPDATE_TOAST_ID);

  toast(
    'New version available! Click to refresh.',
    {
      id: UPDATE_TOAST_ID,
      duration: 15000,
      position: 'top-center',
      style: {
        background: '#4f46e5',
        color: '#fff',
        padding: '12px 20px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(79, 70, 229, 0.4)',
        fontSize: '14px',
        fontWeight: 500,
        cursor: 'pointer',
      },
      icon: '🔄',
    }
  );

  // Handle click on the toast to reload
  const clickHandler = (e: MouseEvent) => {
    const target = e.target as HTMLElement;
    // Check if click is inside the toast
    const toastEl = target.closest('[role="status"]');
    if (toastEl && toastEl.textContent?.includes('New version')) {
      toast.dismiss(UPDATE_TOAST_ID);
      window.location.reload();
    }
  };

  document.addEventListener('click', clickHandler);

  // Clean up after toast disappears
  setTimeout(() => {
    document.removeEventListener('click', clickHandler);
  }, 16000);
};
